var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('organization-load-guard',{attrs:{"organizationId":_vm.organizationId}},[_c('organization-user-settings',{attrs:{"member-id":_vm.memberId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }